import React from 'react';

import { Box, Dialog, DialogProps, BoxProps } from '@material-ui/core';

import { FileResponse } from './index';
import { DialogManagementFileProps } from './index.private.interfaces';

export interface DialogManagementProps extends Omit<DialogProps, 'open'>, DialogManagementFileProps {
  content: (file: FileResponse) => React.ReactNode;
}

export default function DialogManagement(props: DialogManagementProps) {
  const { file, open, content, ...dialogProps } = props;

  const isOpen = open !== undefined ? open && Boolean(file) : Boolean(file);

  // Store file in order to animate fade-out
  const [current, setCurrent] = React.useState<FileResponse | undefined>(undefined);

  React.useEffect(() => {
    if (file) setCurrent(file);
  }, [file]);

  return (
    <Dialog open={isOpen} {...dialogProps}>
      {current && content(current)}
    </Dialog>
  );
}

export function FormControl(props: BoxProps) {
  return (
    <Box
      component="form"
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()}
      {...props}
    ></Box>
  );
}
